import React, { useState, useContext, useEffect, Dispatch } from 'react';
import { Row, Typography, Modal, Button, Checkbox } from 'antd';
import { FaCaretDown } from 'react-icons/fa';
import i18n from 'i18next';
import _ from 'lodash';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import Seek from '../../../assets/images/png/swap/iseek.png';
import Offer from '../../../assets/images/png/swap/offer.png';
import i18next from 'i18next';

export interface RestrictionsState {
  title: string;
  checked: boolean;
  icon: string;
}

export interface RestrictionModalState extends RestrictionsState {
  onChange: (e: CheckboxChangeEvent) => void;
}

export interface RestrictionContextProps {
  restriction: RestrictionsState[];
  category: string[];
  setCategory?: Dispatch<React.SetStateAction<string[]>>;
  handleRestrictionContextChange?: () => void;
}

interface SelectedState {
  items: RestrictionsState;
}

interface RestrictionProps {
  items: RestrictionsState[];
  onPressSave?: (e?: React.MouseEvent) => void;
}

const restriction = [
  {
    title: 'Seek',
    checked: false,
    icon: Seek,
  },
  {
    title: 'Offer',
    checked: false,
    icon: Offer,
  },
];

export const RestrictionContext = React.createContext<RestrictionContextProps>({
  restriction,
  category: [],
});

export const resetRestriction = () => {
  restriction.map(r => {
    r.checked = false;
    return r;
  });
};

export const ModalItems: React.FC<RestrictionModalState> = ({
  title,
  checked,
  icon,
  onChange,
}) => {
  return (
    <div className="filter-content-items">
      <img src={icon} alt="" />
      <div className="filter-content-title">
        <span>{i18next.t(title)}</span>
      </div>
      <Checkbox checked={checked} onChange={onChange} />
    </div>
  );
};

export const RestrictionModalContent: React.FC<RestrictionProps> = ({
  items,
  onPressSave,
}) => {
  const [tempRestriction, setTempRestriction] = useState(items);
  const handleChangeEvent = (i: number) => (e: CheckboxChangeEvent) => {
    const newRestriction = Object.assign({}, tempRestriction);
    newRestriction[i].checked = !newRestriction[i].checked;
    setTempRestriction(Object.values(newRestriction));
  };

  return (
    <div className="modal-content-wrapper">
      <Typography.Title level={4}>{i18n.t('Restrictions')}</Typography.Title>
      {items.map((item, i) => (
        <ModalItems
          key={item.title}
          title={item.title}
          icon={item.icon}
          checked={item.checked}
          onChange={handleChangeEvent(i)}
        />
      ))}
      <div className="button-container filter-button">
        <Button
          block
          type="primary"
          shape="round"
          onClick={onPressSave}
          className="continue-button continue-button-primary"
        >
          <span className="continue-button-text">{i18n.t('Save')}</span>
        </Button>
      </div>
    </div>
  );
};

export const SelectedRestrictionItems: React.FC<SelectedState> = ({
  items,
}) => {
  return (
    <div className="filter-selected-items">
      <img src={items.icon} alt="" />
      <div className="filter-content-title">
        <span>{_.upperFirst(_.toLower(i18next.t(items.title)))}</span>
      </div>
    </div>
  );
};

export const RestrictionsMenu: React.FC = () => {
  const [restrictionItems, setRestrictionItems] = useState(restriction);
  const { handleRestrictionContextChange } = useContext(RestrictionContext);
  const handleOnPressSave = () => {
    setRestrictionItems(restrictionItems);
    handleRestrictionContextChange && handleRestrictionContextChange();
    Modal.destroyAll();
  };

  const restrictionModalConfig = {
    icon: null,
    false: true,
    className: 'modal-content-container modal-content-description',
    style: { top: 50 },
    okButtonProps: { style: { display: 'none' } },
    content: (
      <RestrictionModalContent
        items={restrictionItems}
        onPressSave={handleOnPressSave}
      />
    ),
  };

  const handleButtonPress = () => {
    Modal.info(restrictionModalConfig);
  };

  useEffect(() => {
    return () => {
      resetRestriction();
    };
  }, []);
  return (
    <React.Fragment>
      <Row className="restrictions-wrapper">
        <Typography.Text className="filter-menu-title">
          {i18n.t('Restrictions')}
        </Typography.Text>
        <Button
          shape="round"
          className="filter-buttons filter-restrictions-menu"
          onClick={handleButtonPress}
        >
          {i18n.t('Select')} <FaCaretDown />
        </Button>
      </Row>
      <Row className="filter-selected-container">
        {restrictionItems.map(
          (item, i) =>
            item.checked && <SelectedRestrictionItems key={i} items={item} />
        )}
      </Row>
    </React.Fragment>
  );
};
